import notifyError from "./notifyError"
import api from "../utils/api"

const SendMail = async (
  data = null,
  formTitle = null,
  emailSubject = "",
  emailBodyTitle = "Form details:"
) => {
  if (data) {
    // submit the form

    const to =
      process.env.NODE_ENV === "development"
        ? "mahesh.samudra@worksimply.com"
        : data.toEmail || process.env.GATSBY_DEFAULT_EMAIL_ADDRESS

    if (process.env.NODE_ENV === "development") {
      console.log("exit in local")
      return
    }

    const formData = {
      to,
      userEmail: data.email,
      sp_slug: "workplaceone",
      replyTo: data.email,
      emailTitle: emailSubject || `[Form Submission] ${document.title}`,
      emailBodyTitle,
      emailData: [
        {
          label: "Submitted from",
          value: `<a href="${
            typeof window !== "undefined" ? window.location.href : "#"
          }" target="">${formTitle || document.title}</a>`,
        },
        ...data.formData,
      ],
      from: data.from || `Workplace One Website <no-reply@worksimply.com>`,
    }

    await api("handle-form", formData)
      .then(async (res) => {
        return true
      })
      .catch(async (error) => {
        console.log(error)

        notifyError(
          `Email sending failed from the API - ${error}\n\`${JSON.stringify(
            data
          )}\``
        )
      })
    return true
  } else {
    return false
  }
}

export default SendMail
